import { RouteInfo } from './vertical-menu.metadata';

export const pendingAppointments: any = '';
// Sidebar menu Routes and data
export const ROUTES: RouteInfo[] = [];
